import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const EssayHistory = () => {

  const [data, setData] =
    useState([]);

  const [currentPage, setCurrentPage] =
    useState(1);

  const navigate =
    useNavigate();

  const rowsPerPage = 10;

  const isMobile =
    window.innerWidth < 768;

  /* ================= NAVBAR ================= */

  useEffect(() => {

    const navbar =
      document.querySelector(".navbar");

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity =
          "0";

      }

    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";

    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

    };

  }, []);




  /* ================= LOAD HISTORY ================= */

  useEffect(() => {

    const loadHistory = async () => {

      try {

        const user = JSON.parse(localStorage.getItem("user"));
        const guestToken = localStorage.getItem("guest_token");

        const response = await fetch(

          `https://edunet.kmechengineering.com/root-engine1/api/essay-history?user_id=${user?.id || ""}&guest_token=${guestToken || ""}&t=${Date.now()}`,

          {
            method: "GET",
            cache: "no-store",
            headers: {
              "Cache-Control": "no-cache"
            }
          }

        );

        const res = await response.json();

        console.log("ESSAY HISTORY =>", res);

        if (res.status === true || res.status === "true") {

          setData(res.history_data || []);

        }

      } catch (err) {

        console.log("HISTORY ERROR =>", err);

      }

    };

    loadHistory();

  }, []);

  /* ================= PAGINATION ================= */

  const indexOfLast =
    currentPage * rowsPerPage;

  const indexOfFirst =
    indexOfLast - rowsPerPage;

  const currentData =
    data.slice(
      indexOfFirst,
      indexOfLast
    );

  const totalPages =
    Math.ceil(
      data.length / rowsPerPage
    );

  return (

    <div style={styles.container}>

      <h2 style={styles.title}>
        Essay History
      </h2>

      {data.length === 0 ? (

        <p style={{ color: "#fff" }}>
          No history found
        </p>

      ) : (

        <>

          <div
            style={
              styles.tableWrapper
            }
          >

            <table
              style={styles.table}
            >

              <thead>

                <tr>

                  <th style={styles.th}>
                    Date
                  </th>

                  <th style={styles.th}>
                    Subject
                  </th>

                  <th style={styles.th}>
                    Teacher
                  </th>

                  <th style={styles.th}>
                    Score
                  </th>

                  <th style={styles.th}>
                    Type
                  </th>

                  <th style={styles.th}>
                    Action
                  </th>

                </tr>

              </thead>

              <tbody>

                {currentData.map(
                  (item, i) => (

                    <tr
                      key={
                        item.id || i
                      }
                      style={
                        i % 2 === 0
                          ? styles.rowEven
                          : styles.rowOdd
                      }
                    >

                      <td style={styles.td}>
                        {item.attempt_date}
                      </td>

                      <td style={styles.td}>
                        {item.subject_name}
                      </td>

                      <td style={styles.td}>
                        {item.teacher_name}
                      </td>

                      <td style={styles.td}>
                        {item.marks}/
                        {item.total_marks}
                      </td>

                      <td style={styles.td}>

                        <span
                          style={
                            item.type ===
                            "paid"
                              ? styles.paid
                              : styles.free
                          }
                        >

                          {item.type}

                        </span>

                      </td>

                      <td
                        style={{
                          ...styles.td,
                          textAlign:
                            "center"
                        }}
                      >

                        <button
                          type="button"

                          style={
                            styles.reviewBtn
                          }

                          onClick={(e) => {

                            e.preventDefault();

                            e.stopPropagation();

                            console.log(
                              "REVIEW ITEM =>",
                              item
                            );

                            let parsedAnswers = {};

                            try {

                              if (
                                item.answers
                              ) {

                                if (
                                  typeof item.answers ===
                                  "object"
                                ) {

                                  parsedAnswers =
                                    item.answers;

                                }

                                else {

                                  parsedAnswers =
                                    JSON.parse(
                                      item.answers
                                    );

                                }

                              }

                            }

                            catch (err) {

                              console.log(
                                "ANSWER PARSE ERROR =>",
                                err
                              );

                              parsedAnswers =
                                {};

                            }

                            localStorage.setItem(

                              "review_essay_data",

                              JSON.stringify({

                                answers: Array.isArray(parsedAnswers)
                                  ? parsedAnswers.reduce((obj, item) => {

                                      obj[item.essay_id] = item;

                                      return obj;

                                  }, {})
                                  : parsedAnswers,

                                answerResults: parsedAnswers,

                                marks: item.marks,

                                total_marks: item.total_marks,

                                subject_name: item.subject_name,

                                teacher_name: item.teacher_name,

                                subject_id: item.subject_id,

                                module_id: item.module_id,

                                teacher_id: item.teacher_id,

                                essayType: item.essay_type,

                                type: item.type

                              })

                            );

                            /* ================= FREE ================= */

                            if (
                              item.type ===
                              "free"
                            ) {

                              navigate(
                                `/essay/paper/${item.teacher_id}?module_id=${item.module_id}&review=true`
                              );

                            }

                            /* ================= PAID ================= */

                            else {

                              navigate(
                                `/essay/paid/teacher/${item.teacher_id}/${item.module_id}/${item.total_marks}?type=${item.essay_type}&review=true`
                              );

                            }

                          }}

                        >

                          📄 Review Paper

                        </button>

                      </td>

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

          {/* ================= PAGINATION ================= */}

          <div
            style={
              styles.pagination
            }
          >

            <button
              style={{
                ...styles.pageBtn,

                opacity:
                  currentPage === 1
                    ? 0.5
                    : 1
              }}
              onClick={() =>
                setCurrentPage(
                  p => p - 1
                )
              }
              disabled={
                currentPage === 1
              }
            >

              Prev

            </button>

            <span
              style={{
                color: "#fff",

                fontWeight:
                  "bold"
              }}
            >

              Page {currentPage} / {totalPages}

            </span>

            <button
              style={{
                ...styles.pageBtn,

                opacity:
                  currentPage ===
                  totalPages
                    ? 0.5
                    : 1
              }}
              onClick={() =>
                setCurrentPage(
                  p => p + 1
                )
              }
              disabled={
                currentPage ===
                totalPages
              }
            >

              Next

            </button>

          </div>

          {/* ================= BACK BUTTON ================= */}

          <div
            style={{
              marginTop: "20px"
            }}
          >

            <button
              style={
                styles.backBtn
              }
              onClick={() =>
                navigate("/profile")
              }
            >

              Back

            </button>

          </div>

        </>

      )}

    </div>

  );

};

export default EssayHistory;

const isMobile =
  window.innerWidth < 768;

const styles = {

  container: {

    marginTop: isMobile
      ? "90px"
      : "20px",

    width: "100%",

    padding:
      isMobile
        ? "0 10px"
        : "0"

  },

  title: {

    color: "#fff",

    marginBottom: "20px",

    fontSize:
      isMobile
        ? "18px"
        : "28px"

  },

  tableWrapper: {

    width: "100%",

    overflowX: "auto",

    WebkitOverflowScrolling:
      "touch"

  },

  table: {

    width: "100%",

    borderCollapse:
      "collapse",

    color: "#fff",

    minWidth:
      isMobile
        ? "850px"
        : "100%"

  },

  th: {

    background:
      "#111827",

    padding:
      isMobile
        ? "12px 10px"
        : "14px 12px",

    textAlign:
      "left",

    borderBottom:
      "1px solid #374151",

    whiteSpace:
      "nowrap"

  },

  td: {

    padding:
      isMobile
        ? "12px 10px"
        : "14px 12px",

    borderBottom:
      "1px solid #1f2937",

    whiteSpace:
      "nowrap"

  },

  rowEven: {

    background:
      "#1f2937"

  },

  rowOdd: {

    background:
      "#111827"

  },

  paid: {

    background:
      "#f59e0b",

    padding:
      "5px 10px",

    borderRadius:
      "999px",

    fontWeight:
      "bold"

  },

  free: {

    background:
      "#10b981",

    padding:
      "5px 10px",

    borderRadius:
      "999px",

    fontWeight:
      "bold"

  },

  reviewBtn: {

    background:
      "#2563eb",

    color:
      "#fff",

    border:
      "none",

    padding:
      isMobile
        ? "8px 12px"
        : "10px 18px",

    borderRadius:
      "10px",

    cursor:
      "pointer",

    fontWeight:
      "bold",

    fontSize:
      isMobile
        ? "12px"
        : "14px"

  },

  pagination: {

    marginTop:
      "20px",

    display:
      "flex",

    justifyContent:
      "center",

    alignItems:
      "center",

    gap:
      isMobile
        ? "8px"
        : "12px",

    flexWrap:
      "wrap"

  },

  pageBtn: {

    background:
      "#374151",

    color:
      "#fff",

    border:
      "none",

    padding:
      isMobile
        ? "6px 12px"
        : "8px 16px",

    borderRadius:
      "8px",

    cursor:
      "pointer",

    fontWeight:
      "bold"

  },

  backBtn: {

    background:
      "#10b981",

    color:
      "#fff",

    border:
      "none",

    padding:
      isMobile
        ? "8px 16px"
        : "10px 20px",

    borderRadius:
      "10px",

    cursor:
      "pointer",

    fontWeight:
      "bold"

  }

};


